var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_002-facebook",
    "data-name": "002-facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 25,
    viewBox: "0 0 12.5 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M135.813,8.594V5.469a1.563,1.563,0,0,1,1.563-1.562h1.563V0h-3.125a4.687,4.687,0,0,0-4.687,4.688V8.594H128V12.5h3.125V25h4.688V12.5h3.125L140.5,8.594Z",
    transform: "translate(-128)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.f11c63bd7f5a6d7e6373c04919115074.svg";
export { ForwardRef as ReactComponent };